import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import { Button } from '../../components/atoms/Button'
import { useAuth } from '../../../context/AuthContext'
import { ROUTES } from '../../../constants/routes.constants'
import { Stagger, StaggerItem } from '../../motion'

/** `/account` — landing page for the account section. */
export function AccountDashboardPage(): JSX.Element {
  const { user, logout } = useAuth()
  const display = user?.firstName ?? user?.email ?? 'there'
  return (
    <>
      <Helmet>
        <title>Your account — Uyyamadilu</title>
      </Helmet>
      <header className="mb-8">
        <h1 className="font-heading text-h1 text-charcoal">Welcome back, {display}.</h1>
        <p className="mt-2 font-body text-body text-text-secondary">
          From here you can manage your profile and review past orders.
        </p>
      </header>

      <Stagger className="grid sm:grid-cols-2 gap-4" amount={0.05} step={0.1}>
        <StaggerItem>
          <Link
            to={ROUTES.ACCOUNTPROFILE}
            className="block rounded-2xl border border-border p-6 bg-bg-primary transition-all duration-500 ease-cinematic hover:-translate-y-1 hover:border-forest hover:shadow-lg"
          >
            <h2 className="font-heading text-h3 text-charcoal">Profile</h2>
            <p className="mt-1 font-body text-body-sm text-text-secondary">
              Update your name, phone, address, and marketing preferences.
            </p>
          </Link>
        </StaggerItem>
        <StaggerItem>
          <Link
            to={ROUTES.ACCOUNTORDERS}
            className="block rounded-2xl border border-border p-6 bg-bg-primary transition-all duration-500 ease-cinematic hover:-translate-y-1 hover:border-forest hover:shadow-lg"
          >
            <h2 className="font-heading text-h3 text-charcoal">Orders</h2>
            <p className="mt-1 font-body text-body-sm text-text-secondary">
              View past orders, track shipments, and download invoices.
            </p>
          </Link>
        </StaggerItem>
      </Stagger>

      <div className="mt-10">
        <Button variant="ghost" onClick={() => { void logout() }}>
          Sign out
        </Button>
      </div>
    </>
  )
}
